const AMAZE_TUTORIAL = "https://drive.google.com/file/d/1gH7NPCU0KFEM5gLnD7HHPpYbRyT-MRZx/preview";
const VIDEO_TITLE = "demoVideo";

const KEYWORD_TUTORIAL = "https://drive.google.com/file/d/1lmgBUbl-c-QrUL11s6v5E-TndMJVZtD1/preview";

const HOMOPHONE_TUTORIAL = "https://drive.google.com/file/d/1su2HupKr0DHZRSRjIc4hLUBB0f_2-fS9/preview";

export { AMAZE_TUTORIAL, HOMOPHONE_TUTORIAL, KEYWORD_TUTORIAL, VIDEO_TITLE };
